// here trying to see if we can use ts instead of tsxs

import AppHeader from "./AppHeader";


export default AppHeader